module.exports = __webpack_public_path__ + "static/media/promo.01746d20.png";